import { __decorate } from "tslib";
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import WindowSizeListener from '@/helpers/vue_mixins/v3/WindowSizeListenerMixin';
let ComponentName = class ComponentName extends Mixins(ViewportSizeMixin, RouterParamsAppMixin, WindowSizeListener) {
    get selectedImage() {
        if (Array.isArray(this.notificationFormData?.image)) {
            const filteredImages = this.notificationFormData?.image.filter((img) => img.state === 'idle' || img.state === 'new');
            const filteredImagesLength = filteredImages.length;
            return (filteredImages[filteredImagesLength - 1]?.url ||
                filteredImages[filteredImagesLength - 1]?.file.dataURL);
        }
        return this.notificationFormData?.image?.file?.photoUrl || '';
    }
};
__decorate([
    Prop({ type: Object, required: true })
], ComponentName.prototype, "notificationFormData", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], ComponentName.prototype, "isSendNotification", void 0);
ComponentName = __decorate([
    Component({
        components: {
        // Your component components here
        },
        apollo: {
        // Your component apollo queries here
        },
    })
], ComponentName);
export default ComponentName;
